var map = {
	"./SCP_Studio_Collect_Logo_White.png": 478,
	"./VEVA-Cube-Glow (copy).png": 479,
	"./VEVA-Cube-Glow.png": 480,
	"./login-background.jpg": 481,
	"./logo-veva.svg": 195,
	"./logo.veva-collect-white.png": 482,
	"./new-logo.png": 121,
	"./ph.hero.projects.jpg": 483,
	"./ph.j+y.background.jpg": 484,
	"./ph.j+y.thumbnail.jpg": 485,
	"./ph.samokell.jpg": 486,
	"./studio-collect.svg": 487,
	"./user-icon.png": 488
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 477;